import { useState } from "react";

import { useApi } from "@/lib/api";

interface MoodOption {
  id: string;
  label: string;
  value: number;
}

export function MoodScale(props: {
  question: string;
  options: MoodOption[];
  onPick: (label: string) => void;
}) {
  const api = useApi();
  const [picked, setPicked] = useState<string | null>(null);
  const locked = picked !== null;

  return (
    <div className="space-y-3">
      {props.question && <div className="text-sm">{props.question}</div>}
      <div className="grid grid-cols-5 gap-2">
        {props.options.map((o) => {
          const isPicked = picked === o.id;
          return (
            <button
              key={o.id}
              disabled={locked}
              onClick={() => {
                setPicked(o.id);
                // Persist as a memory_fact in parallel with sending the chat
                // message, so mood history accumulates whether or not the
                // coach happens to call `remember` this turn.
                void api("/api/me/mood", {
                  method: "POST",
                  body: JSON.stringify({ value: o.value, label: o.label }),
                }).catch(() => {});
                props.onPick(o.label);
              }}
              className={
                "rounded-2xl border p-2 text-center text-xs transition disabled:cursor-not-allowed " +
                (isPicked
                  ? "border-neutral-900 bg-neutral-900 text-white"
                  : locked
                    ? "border-neutral-200 bg-neutral-50 text-neutral-400"
                    : "border-neutral-300 bg-white text-neutral-900 hover:border-neutral-500")
              }
            >
              <div className="text-2xl">{o.label.slice(0, 2)}</div>
              <div className="mt-1 leading-tight">{o.label.slice(2).trim()}</div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
